import { Trans, useLingui } from '@lingui/react/macro';

import IconUserMail from '@/icons/UserMail.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingClientContactNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_client_contact'>;
}) => {
  const { t } = useLingui();
  const reference = notification.request.reference;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.pending_client_contact.label',
        message: `You have a new client outreach task to do on request ${reference}`,
      })}
      icon={<IconUserMail />}
      type="new"
      notification={notification}
      notificationHeader={() => (
        <Trans id="notification.pending_client_contact">
          You have a new client outreach task to do
        </Trans>
      )}
    />
  );
};
